import React, { useState, useEffect } from "react";
import { Segment, Container, Table, Button } from "semantic-ui-react";
import PayslipsBulkUploadForm from "./PayslipsBulkUploadForm";
import { deletePayslip, confirmMapping, getCompanies } from "../payslipsActions";
import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();

export default function PayslipsBulkPage(props) {
    const [payslips, setPayslips] = useState([]);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const unsubscribe = firestore
            .collection("payslips")
            .where("status", "==", "Unsorted")
            .onSnapshot((snapshot) => {
                let list = [];
                snapshot.docs.forEach((result) => {
                    if (result.exists) {
                        let obj = { ...result.data(), id: result.id };
                        list.push(obj);
                    }
                });
                setPayslips(list);
            });

        getCompanies().then(
            (res) => {
                let list = [];
                res.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        list.push(appObj);
                    }
                });
                setCompanies(list);
            },
            (err) => {
                console.log(err);
            }
        );

        return () => unsubscribe();
    }, []);

    function confirmMappingData(value) {
        confirmMapping(value);
    }
    function deleteMappingData(payslip) {
        deletePayslip(payslip);
    }
    return (
        <Container>
            <Segment>
                <PayslipsBulkUploadForm payslips={payslips} companies={companies} />
            </Segment>

            <Segment>
                {payslips && payslips.length > 0 ? (
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Payslip Date</Table.HeaderCell>
                                <Table.HeaderCell>Company</Table.HeaderCell>
                                <Table.HeaderCell>File Name</Table.HeaderCell>
                                <Table.HeaderCell>Suggested Map</Table.HeaderCell>
                                <Table.HeaderCell width={4}>Actions</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {payslips.map((ps) => (
                                <Table.Row key={ps.id}>
                                    <Table.Cell>{ps.documentName}</Table.Cell>
                                    <Table.Cell>{ps.companyName}</Table.Cell>
                                    <Table.Cell>
                                        <Button as="a" target="_blank" href={ps.fileUrl}>
                                            {ps.fileName}
                                        </Button>
                                    </Table.Cell>

                                    <Table.Cell>
                                        {ps.userUid && ps.userUid.length > 0 && ps.displayName && ps.displayName.length > 0 && ps.employeeNr && ps.employeeNr > 0 && (
                                            <p>
                                                {ps.displayName} - {ps.employeeNr}
                                            </p>
                                        )}
                                    </Table.Cell>

                                    <Table.Cell textAlign="center">
                                        {ps.userUid && ps.userUid.length > 0 && ps.displayName && ps.displayName.length > 0 && ps.employeeNr && ps.employeeNr > 0 && (
                                            <Button as="a" color="blue" onClick={() => confirmMappingData(ps)}>
                                                CONFIRM
                                            </Button>
                                        )}

                                        <Button as="a" color="red" onClick={() => window.confirm("Are you sure you wish to delete this item?") && deleteMappingData(ps)}>
                                            DELETE
                                        </Button>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                ) : (
                    <p>No payslips to map, upload a payslip above</p>
                )}
            </Segment>
        </Container>
    );
}
